import type {
  EnvironmentKey,
  EnvironmentService,
} from '../application/EnvironmentService/EnvironmentService';

export class NextRuntimeEnvironmentService implements EnvironmentService {
  private readonly env: Record<string, string | undefined>;
  constructor(env: Record<string, string | undefined>) {
    this.env = env;
  }
  get(
    key: EnvironmentKey,
    {
      allowEmptyString,
      allowUndefined,
    }: {
      allowEmptyString?: boolean;
      allowUndefined?: boolean;
    } = {},
  ): string {
    const value = this.getPossiblyUndefined(key);
    if (allowEmptyString && value === '') {
      return value;
    }
    if (!value && !allowUndefined) {
      throw new Error(`Environment variable ${key} is not defined`);
    }
    return value || '';
  }

  getPossiblyUndefined(key: EnvironmentKey): string | undefined {
    return this.env[`NEXT_${key}`];
  }

  getBoolean(
    key: EnvironmentKey,
    { throwIfUndefined }: { throwIfUndefined?: boolean } = {
      throwIfUndefined: false,
    },
  ): boolean {
    const value = throwIfUndefined
      ? this.get(key, { allowEmptyString: true })
      : this.getPossiblyUndefined(key);
    return value && JSON.parse(value);
  }
}
